<template>
    <div class="flex justify-content-between w-full" :class="hourlyAbsence.action !== 'delete' ? 'justify-content-start': 'justify-content-start'"> 
        <div class="flex-column">
            <p class="p-0 mb-1 text-600 font-semibold">{{ absenceAction }}</p>
            <h5 class="p-0 m-0">{{hourlyAbsence.request.meta.first_name}} {{hourlyAbsence.request.meta.last_name}}</h5>
            <ul>
                <li v-for="(item, index) in hourlyAbsence.request.meta.details" :key="index">    
                    {{ dateToGermanDateStr(new Date(item.start_date_time)) }}: {{ dateToTimeStr(new Date(item.start_date_time)) }} - {{ dateToTimeStr(new Date(item.end_date_time)) }} Uhr
                </li>
            </ul>
        </div>

        <div class="flex w-6 align-items-center" :class="detailsButtonArrangementClass">
            <i v-if="userRole === 'admin'" class="pi pi-info-circle message-icon mr-3" @click="showDetails"/>
            <i v-badge="numMessages" class="pi pi-envelope message-icon" @click="toggle"/>
        </div>

        <OverlayPanel ref="op" class="border-round-3xl p-shiftify-chat">
            <div class="overlay-panel">
                <Chat 
                :employeeId="userId" 
                :messages="messages" 
                :requestId="hourlyAbsence.request.id"
                @updateParent="updateComponent"
                />
            </div> 
        </OverlayPanel>
    </div>

</template>

<script>
import {dateToTimeStr, dateToGermanDateStr} from '../../../js_utilities/dateUtils.js'
import Chat from '../../Chat/Chat.vue'

export default {
    data() {
        return {
            userRole: null,
            dateToTimeStr,
            dateToGermanDateStr
        }
    },

    props: {
        hourlyAbsence: {
            type: Object,
            required: true
        }
    },

    components: {Chat},

    computed: {
        detailsButtonArrangementClass() {
            return "justify-content-end"
        },

        userId() {
            return this.$store.getters.getLoggedInUser.uuid
        },

        messages(){
            return this.hourlyAbsence?.request?.messages ?? [];
        },
        numMessages(){
            return this.hourlyAbsence?.request?.messages?.length.toString() ?? "0";
        },

        absenceAction(){
            const typeName = this.hourlyAbsence.request.meta?.absence_type?.name || "Abwesenheit"
            if (this.hourlyAbsence.request.action == "create") {
                return `Antrag ${typeName}`
            } else if (this.hourlyAbsence.request.action == "delete") {
                return `Antrag Löschung ${typeName}`
            } else if (this.hourlyAbsence.request.action == "update") {
                return `Antrag Änderung ${typeName}`
            } else {
                return ""
            }
        }
    },

    emits: ["close", "updateParent"],


    methods: {
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        updateComponent() {
            console.log("updateParent from RequestHourlyAbsenceUpdateDetails component")
            this.$emit("updateParent")
        },

        showDetails(){
            console.log("showDetails hourly absence details")
            console.log(this.hourlyAbsence)
            let department_id = this.hourlyAbsence.request?.requester_employee?.department?.id || null;
            
            if (department_id !== null){
                let path = `/holidayplanner/${this.hourlyAbsence.request.meta.details[0].start_date_time}/${this.hourlyAbsence.request.meta.details[0].end_date_time}/${department_id}`
                console.log(path)
                this.$router.push({ 
                    path: path, 
                });
            } else {
                let path = `/holidayplanner/${this.hourlyAbsence.request.meta.details[0].start_date_time}/${this.hourlyAbsence.request.meta.details[0].end_date_time}`
                console.log(path)
                this.$router.push({ 
                    path: path, 
                });
            }
            this.$emit("close")

        }
    },

    mounted(){
        console.log("RequestHourlyAbsenceDetails")
        console.log(this.hourlyAbsence)
    },

    created(){
        this.userRole = this.$store.getters.getLoggedInUser.role.name
    }
}
</script>


<style scoped>
.label-text {
    font-size: 1rem !important;
  }

.button-height{
    height: 1.5rem;
}

.p-button{
    color: rgba(60, 55, 220, 1.0) !important;
    background-color: rgba(60, 55, 220, 0.05) !important;
}

.p-button:hover{
    color: rgba(60, 55, 220, 1.0) !important;
    background-color: rgba(60, 55, 220, 0.25) !important;
}

.overlay-panel {
    width: 50vw;
    height: 50vh;
}

.message-icon{
    font-size: 1.5rem;
    transition: font-size 0.15s ease-in-out;
}

.message-icon:hover{
    font-size: 1.75rem
}
</style>